import React, { useEffect, useState } from 'react'
import { faCheck, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { toast } from 'react-toastify'
import { useTranslation } from "react-i18next"
import { useLocation, useHistory } from 'react-router-dom'
import mainAxios from '../../../services/mainAxios'
import Loader from '../../Layout/Loader'
import Lottie from "lottie-react";
import onlineBank from '../../../design/assets/ProfiscLogin.json'
import '../../../components/Auth/Auth.scss'

const InviteSetPassword = () => {
    const { t } = useTranslation('translations')
    const location = useLocation()
    const history = useHistory()

    const [verificationState, setVerificationState] = useState({
        loading: true,
        verified: false,
        error: null,
        user: null
    })

    const [passwordType, setPasswordType] = useState({
        newPassword: "password",
        confirmPassword: "password"
    })

    const [state, setState] = useState({
        newPassword: "",
        confirmPassword: "",
        error: null,
        error_password: null
    })

    const [submitLoading, setSubmitLoading] = useState(false)

    const token = new URLSearchParams(location.search).get("token")

    useEffect(() => {
        if (!token) {
            setVerificationState({
                loading: false,
                verified: false,
                error: t('invite.invalidLink'),
                user: null
            })
            return
        }

        validateToken()
    }, [token])

    const validateToken = () => {
        setVerificationState(prev => ({ ...prev, loading: true }))

        mainAxios.post('/invitations/validate', {
            value: token
        }).then(res => {
            if (res?.data?.status === true) {
                setVerificationState({
                    loading: false,
                    verified: true,
                    error: null,
                    user: res.data.content?.[0] || null
                })
            } else {
                setVerificationState({
                    loading: false,
                    verified: false,
                    error: res?.data?.message || t('invite.invalidToken'),
                    user: null
                })
            }
        }).catch(err => {
            setVerificationState({
                loading: false,
                verified: false,
                error: t('invite.verificationFailed'),
                user: null
            })
        })
    }

    const handlePasswordInputs = (e) => {
        const key = e.target.name
        const value = e.target.value

        setState(state => ({
            ...state,
            [key]: value,
            error: null,
            error_password: null
        }))
    }

    const handleSetPassword = (e) => {
        e.preventDefault()

        if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/.test(state.newPassword)) {
            setState(state => ({
                ...state,
                error_password: t('toast.passwordError')
            }))
            return
        }

        if (state.newPassword !== state.confirmPassword) {
            setState(state => ({
                ...state,
                error: t('toast.identical')
            }))
            return
        }

        setSubmitLoading(true)

        mainAxios.post('/invitations/set-password', {
            params: JSON.stringify({
                password: state.newPassword,
                token: token
            })
        }).then(res => {
            if (res?.data?.status === true) {
                toast.success(t('invite.passwordSetSuccess'), {
                    containerId: "all_toast"
                })
                history.push('/')
            } else {
                toast.error(res?.data?.message || t('invite.passwordSetFailed'), {
                    containerId: "all_toast"
                })
            }
            setSubmitLoading(false)
        }).catch(err => {
            toast.error(t('invite.passwordSetFailed'), {
                containerId: "all_toast"
            })
            setSubmitLoading(false)
        })
    }

    if (verificationState.loading) {
        return (
            <div className="auth-page-container">
                <div className="auth-sidebar">
                    <div className="sidebar-content">
                        <div className="sidebar-logo">
                            <img src="/Logo-Profisc-2.png" alt="Profisc" />
                        </div>
                        <h2 className="sidebar-title">
                            {t('login.slogan')}
                        </h2>
                    </div>
                    <Lottie className="sidebar-animation" animationData={onlineBank} loop={false} />
                </div>
                <div className="auth-form-wrapper">
                    <div className="auth-form-container" style={{ textAlign: 'center' }}>
                        <div style={{ padding: '40px 0' }}>
                            <div style={{
                                width: '60px',
                                height: '60px',
                                margin: '0 auto 30px',
                                position: 'relative'
                            }}>
                                <svg
                                    width="60"
                                    height="60"
                                    viewBox="0 0 60 60"
                                    style={{
                                        animation: 'spin 1.2s linear infinite'
                                    }}
                                >
                                    <circle
                                        cx="30"
                                        cy="30"
                                        r="26"
                                        fill="none"
                                        stroke="#e8f0ef"
                                        strokeWidth="2"
                                    />
                                    <circle
                                        cx="30"
                                        cy="30"
                                        r="26"
                                        fill="none"
                                        stroke="url(#spinner-gradient)"
                                        strokeWidth="2"
                                        strokeDasharray="40 100"
                                        strokeLinecap="round"
                                    />
                                    <defs>
                                        <linearGradient id="spinner-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                            <stop offset="0%" stopColor="#0d5a52" />
                                            <stop offset="100%" stopColor="#0a4940" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                            <h3 className="auth-form-title">
                                {t('invite.verifyingLink') || 'Verifying Link'}
                            </h3>
                            <p className="auth-form-subtitle" style={{ marginTop: '20px', marginBottom: '0' }}>
                                {t('login.waitValidatingLink')}
                            </p>
                            <p style={{ fontSize: '12px', color: '#999', marginTop: '15px' }}>
                                {t('login.waitFewMoments')}
                            </p>
                        </div>
                        <style>{`
                            @keyframes spin {
                                from { transform: rotate(0deg); }
                                to { transform: rotate(360deg); }
                            }
                        `}</style>
                    </div>
                </div>
            </div>
        )
    }

    if (!verificationState.verified) {
        return (
            <div className="auth-page-container">
                <div className="auth-sidebar">
                    <div className="sidebar-content">
                        <div className="sidebar-logo">
                            <img src="/Logo-Profisc-2.png" alt="Profisc" />
                        </div>
                        <h2 className="sidebar-title">
                            {t('login.slogan')}
                        </h2>
                    </div>
                    <Lottie className="sidebar-animation" animationData={onlineBank} loop={false} />
                </div>
                <div className="auth-form-wrapper">
                    <div className="auth-form-container" style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '48px', marginBottom: '20px', color: '#dc3545' }}>
                            ✗
                        </div>
                        <h3 className="auth-form-title" style={{ color: '#dc3545' }}>
                            {t('invite.invalidLink')}
                        </h3>
                        <p className="auth-form-subtitle" style={{ marginBottom: '30px' }}>
                            {verificationState.error}
                        </p>
                        <button
                            className="btn btn-primary"
                            onClick={() => history.push('/')}
                            style={{ minWidth: '150px' }}
                        >
                            {t('invite.goToLogin')}
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="auth-page-container">
            {/* Left Sidebar */}
            <div className="auth-sidebar">
                <div className="sidebar-content">
                    <div className="sidebar-logo">
                        <img src="/Logo-Profisc-2.png" alt="Profisc" />
                    </div>
                    <h2 className="sidebar-title">
                        {t('login.slogan')}
                    </h2>
                </div>
                <Lottie className="sidebar-animation" animationData={onlineBank} loop={false} />
            </div>

            {/* Right Form */}
            <div className="auth-form-wrapper">
                <div className="auth-form-container">
                    <form onSubmit={handleSetPassword}>
                        <h3 className="auth-form-title">
                            {t('invite.setPassword')}
                        </h3>
                        <p className="auth-form-subtitle">
                            {t('login.createStrongPassword')}
                        </p>

                        {state.error && (
                            <div className="error-message">
                                {state.error}
                            </div>
                        )}

                        <div className="form-group">
                            <label htmlFor="new_password">
                                {state.error_password && (
                                    <span className="error-text">{state.error_password}</span>
                                )}
                                {t('users.newPassword')}
                            </label>
                            <div className="password-input-wrapper">
                                <input
                                    type={passwordType.newPassword}
                                    className={"form-control" + (state.error_password ? " border-danger" : "")}
                                    id="new_password"
                                    name="newPassword"
                                    placeholder={t('users.newPassword')}
                                    value={state.newPassword}
                                    onChange={handlePasswordInputs}
                                    required />
                                <span
                                    className="password-toggle"
                                    onClick={() => setPasswordType((prevState) => ({
                                        ...prevState,
                                        newPassword: passwordType.newPassword === "password" ? "text" : "password"
                                    }))}>
                                    <FontAwesomeIcon icon={passwordType.newPassword === "password" ? faEye : faEyeSlash} />
                                </span>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="confirm_password">
                                {t('users.confirmPassword')}
                            </label>
                            <div className="password-input-wrapper">
                                <input
                                    type={passwordType.confirmPassword}
                                    className={"form-control" + (state.error ? " border-danger" : "")}
                                    id="confirm_password"
                                    name="confirmPassword"
                                    placeholder={t('users.confirmPassword')}
                                    value={state.confirmPassword}
                                    onChange={handlePasswordInputs}
                                    required />
                                <span
                                    className="password-toggle"
                                    onClick={() => setPasswordType((prevState) => ({
                                        ...prevState,
                                        confirmPassword: passwordType.confirmPassword === "password" ? "text" : "password"
                                    }))}>
                                    <FontAwesomeIcon icon={passwordType.confirmPassword === "password" ? faEye : faEyeSlash} />
                                </span>
                            </div>
                        </div>

                        <div className="form-actions">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={submitLoading}>
                                {submitLoading ? (
                                    <Loader size="xs" color="white" />
                                ) : (
                                    <>
                                        <FontAwesomeIcon icon={faCheck} className="mr-2" />
                                        {t('common.save')}
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default InviteSetPassword
